import { InvoiceProcessingProfile } from "../InvoiceProcessingProfile";
import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutInvoiceProcessingProfileFilter extends Layout {
    buttonApply: Button;
    buttonCancel: Button;
    buttonReset: Button;
    horizontalspacer1: HorizontalSpacer;
    labelAdvancedFilter: Label;
    layoutProfile: InvoiceProcessingProfile;
    panelHeader: Panel;
    sourceInvoiceProcessingProfile: DataSource;
}
